import axios from 'axios';
import { logout } from './userActions';

export const getWeeklyTrafficData = (watcherId) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const body = JSON.stringify({ watcherId });

    const { data } = await axios.post(`/api/weekly_traffic`, body, config);

    if (data && data.status) {
      return {
        status: data.status,
        data: data.data,
        internal_ips: data.internal_ips,
        external_ips: data.external_ips,
        watchers: data.watchers,
      };
    } else if (data && !data.status) {
      if (data.session_expired) {
        dispatch(logout());
      }
      return { status: false, msg: data.msg };
    } else {
      return { status: false, msg: 'Empty or invalid data received' };
    }
  } catch (err) {
    console.error('Error fetching weekly traffic data:', err);
    // It's good practice to check for response existence
    if (err.response && err.response.data && err.response.data.session_expired) {
      dispatch(logout());
    }
    return { status: false, msg: 'Error fetching data' };
  }
}; 